import React, { useEffect, useState } from "react";
import { IInvoiceServicePosition } from "../../interfaces/IInvoiceServicePosition";
import { IInvoicePartner } from "../../interfaces/IInvoicePartner";
import { IInvoice } from "../../interfaces/IInvoice";
import { OfferPositionTable } from "../offer/Childs/OfferPositionTable";
import { useGetUnits } from "../../hooks/data/data_unit";
import { useGetServiceCategories, useGetServices } from "../../hooks/data/data_service";
import { Box, Card, CardContent, CircularProgress, Typography } from "@mui/material";
import { ErrorTryRefetch } from "../core/ErrorTryRefetch";
import { useGetPartners } from "../../hooks/data/data_partner";
import { IOfferPosition } from "../../interfaces/IOfferPosition";
import { IOfferPartner } from "../../interfaces/IOfferPartner";
import { IOffer } from "../../interfaces/IOffer";
import { OfferPartnerTable } from "../offer/Childs/OfferPartnerTable";

interface IProps {
    invoice: IInvoice;
    setInvoice: Function;
    isOpenNew: boolean;
    setIsOpenNew: Function;
    invoiceServicePositionType: number;
}

export const InvoicePosServiceTable:React.FC<IProps> = ({
    invoice,
    setInvoice,
    isOpenNew,
    setIsOpenNew,
    invoiceServicePositionType
}) => {
    const { units, isLoadingUnits, refetchUnits} = useGetUnits();
    const { serviceArray, isLoadingServices, refetchServices } = useGetServices();
    const {serviceCategoryArray, isLoadingServiceCategories, refetchServiceCategories} = useGetServiceCategories();
    const { partnerArray, isLoadingPartnerArray, refetchPartnerArray} = useGetPartners();
    //
    const [invServicePositions, setInvServicePositions] = useState(invoice.InvoiceServicePositions);
    const [invPartners, setInvPartners] = useState(invoice.InvoicePartners);

    const offerObject:IOffer = {
        ...invoice,
        OfferState: 1,
        OfferType: 1,
        margin: 1,
        OfferPositions: [],
        OfferApplications: [],
        OfferMaterialPositionArray: [],
        OfferPartners: [],
        OfferApplicationDocuments: [],
        ReasonCancellation: null
    }

    useEffect(() => {
        setInvoice({
            ...invoice,
            InvoiceServicePositions: invServicePositions,
            InvoicePartners: invPartners
        })
    },[invServicePositions,invPartners])


    const offerPositionArray = invServicePositions
        .filter(invPos => invoiceServicePositionType === undefined || invPos.InvoiceServicePositionType === invoiceServicePositionType)
        .map(invPos => {
        return {
            ...invPos,
            Offer: invPos.Invoice,
            checkListItems: []
        } as IOfferPosition
    });
    const setOfferPositionArray = (offerPoss:IOfferPosition[]) => {
        setInvServicePositions([
            ...offerPoss.map(offPos => {
                return {
                    ...offPos,
                    Invoice: offPos.Offer,
                    InvoiceServicePositionType: invoiceServicePositionType
                } as IInvoiceServicePosition
            }),
            ...invoice.InvoiceServicePositions.filter(invPos => invPos.InvoiceServicePositionType !== invoiceServicePositionType)
        ])
    }

    const offerPartners = invPartners.map(invPart => {
        return {
            ...invPart,
            Offer: invPart.Invoice,
            selling_price_offer: invPart.selling_price
        } as IOfferPartner;
    })
    const setOfferPartners = (offerPartners:IOfferPartner[]) => {
        setInvPartners([
            ...offerPartners.map(offerPartner => {
                return {
                    ...offerPartner,
                    id: offerPartner.Partner,
                    Invoice: offerPartner.Offer,
                    selling_price: offerPartner.selling_price_offer
                } as IInvoicePartner
            })
        ])
    }


    const refetchAll = () => {
        refetchUnits();
        refetchServices();
        refetchServiceCategories();
        refetchPartnerArray();
    }


    if (
        isLoadingUnits 
        || isLoadingServices
        || isLoadingServiceCategories
        || isLoadingPartnerArray
    ) {
        return <CircularProgress/>
    }

    if (
        !units
        || !serviceArray
        || !serviceCategoryArray
        || !partnerArray
    ) {
        return <ErrorTryRefetch refetchFunction={refetchAll}/>

    }


    return(
        <>
            <OfferPartnerTable
                offerObject={offerObject}
                partnerArray={partnerArray}
                offerPartner={offerPartners}
                setOfferPartner={setOfferPartners}
            />
            <Box sx={{ mt: 10 }} />
            {(invPartners.length === 0) ?
                <Card variant="outlined">
                    <CardContent>
                        <Typography>Bitte Partnerzuordnung hinzufügen!</Typography>
                    </CardContent>
                </Card>
                :
                <OfferPositionTable
                    offerObject={offerObject}
                    offerPositionArray={offerPositionArray}
                    setOfferPosition={setOfferPositionArray}
                    offerPartnerArray={offerPartners}
                    partnerArray={partnerArray}
                    serviceArray={serviceArray}
                    serviceCategoryArray={serviceCategoryArray}
                    isOpenAdd={isOpenNew}
                    setIsOpenAdd={setIsOpenNew}
                    unitArray={units}
                />
            }

        </>
    )
}